import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {HelpSectionInterface} from '../../../models/sharedinterface';

@Component({
  selector: 'app-help-section',
  templateUrl: './help-section.component.html',
  styleUrls: ['./help-section.component.scss']
})
export class HelpSectionComponent implements OnInit {

  @Input() helpSection: HelpSectionInterface;
  @Input() opened?: boolean;

  @ViewChild('content') input;

  constructor() {
  }

  ngOnInit(): void {

  }

  toggleHelp() {
    this.opened = this.opened ? false : true;
  }

}
